export default {
  date: (state, date = new Date()) => (state.date = date),
  calendar: (state, calendar = {}) => (state.calendar = calendar),
  monthCalendar: (state, calendar = {}) => (state.calendarByMonth = calendar),
  setDetail: (state, diary) => (state.detail = diary),
  setDetailDate: (state, date) => (state.detail.date = date)
};
